module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1524-47c58c98e5981f6527518ca2af628e17.png";